/**
 * Build a map of matchId → match payload from challenge picks (API embeds match on each pick).
 * Keys are normalized to string for consistent lookup across challenge card and group history.
 */

import type { ChallengePick } from '../../../types/challenges';

function getMatchFromPick(pick: ChallengePick): unknown {
  return (pick as { match?: unknown }).match;
}

/**
 * Returns Record<matchId, match> from picks. Uses String(matchId) as key.
 */
export function buildMatchByIdFromPicks(picks: ChallengePick[]): Record<string, unknown> {
  const map: Record<string, unknown> = {};
  for (const p of picks) {
    const mid = p.matchId != null && String(p.matchId).trim() !== '' ? String(p.matchId) : null;
    if (mid) {
      const m = getMatchFromPick(p);
      if (m && !map[mid]) map[mid] = m;
    }
  }
  return map;
}
